<template>
  <div>
    <div ref="button" class="flex justify-center"></div>
    <p v-if="loadFailed" class="text-center text-sm text-red-600">{{ t("load_failed") }}</p>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";

// Google Identity Services: renders the official button and emits the Google ID token (credential).
const GIS_SCRIPT_URL = "https://accounts.google.com/gsi/client";

function loadGoogleIdentityServices() {
  if (window.google?.accounts?.id) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = GIS_SCRIPT_URL;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export default {
  emits: ["credential"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return { loadFailed: false };
  },

  async mounted() {
    try {
      await loadGoogleIdentityServices();
    } catch {
      // Google script blocked or unreachable: in production there is no other way to sign in, so say it
      this.loadFailed = true;
      return;
    }

    window.google.accounts.id.initialize({
      client_id: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID,
      callback: ({ credential }) => this.$emit("credential", credential),
    });
    window.google.accounts.id.renderButton(this.$refs.button, {
      theme: "outline",
      size: "large",
      text: "signin_with",
      locale: "fr",
    });
  },
};
</script>

<i18n src="./GoogleSignInButton.i18n.json"></i18n>
